module.exports = __webpack_public_path__ + "static_pc/img/ba13.3bdc5d66.jpg";